/**
* Description: 用于管理布局右边下面区域伸缩时宽高变化的组件，
* 一、提供了多个槽点用于布局显示：
* 1、底层slot，用于加载最下面一层的页面（比如地图）
* 2、悬浮slot，用于加载悬浮的页面，提供了四个位置slot（float-left-top，float-right-top，float-left-bottom，float-right-bottom）
* 二、提供了四个布局属性top、bottom、left、right，用于控制悬浮页面距离上下左右的间距
* 三、wrapWidth用于控制组件宽度是自适应还是精确数值
* @author: lhc
* @date: 2020/8/25 10:15
*/
<template>
    <div :style="{ width: getCurWidth, height: getCurHeight}">
        <slot :height="getCurHeight" :width="getCurWidth" name="bottom-layer"></slot>

        <span :style="{ position: 'absolute', top: top + 'px' }" class="center">
          <slot name="float-top-center" />
        </span>

        <span :style="{ position: 'absolute', bottom: top + 'px'}" class="center">
         <slot name="float-bottom-center"></slot>
       </span>

        <span :style="{ position: 'absolute', top: top + 'px', left: (getLeftMenuWidth + left) + 'px' }">
      <slot :height="getCurHeight" :width="getCurWidth" name="float-left-top"></slot>
    </span>
        <span :style="{ position: 'absolute', top: top + 'px', right: right + 'px' }">
      <slot :height="getCurHeight" :width="getCurWidth" name="float-right-top"></slot>
    </span>

        <span :style="{ position: 'absolute', bottom: bottom + 'px', left: (getLeftMenuWidth + left) + 'px' }">
      <slot :height="getCurHeight" :width="getCurWidth" name="float-left-bottom"></slot>
    </span>

        <span :style="{ position: 'absolute', bottom: bottom + 'px', right: right + 'px' }">
      <slot :height="getCurHeight" :width="getCurWidth" name="float-right-bottom"></slot>
    </span>

        <span :style="{ position: 'absolute', top:  top + 'px', left: left + 'px'}">
      <slot :height="getFloatHeightValue" :width="getCurWidth"></slot>
    </span>

    </div>
</template>

<script>
// import { mixin, mixinDevice } from '@/utils/mixin'

export default {
  name: 'DynamicTag',
  // mixins: [mixin, mixinDevice],
  props: {
    wrapWidth: {
      type: [Boolean,String],
      default: true
    },
    top: {
      type: Number,
      default: 0
    },
    bottom: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      height: window.innerHeight,
      width: window.innerWidth
    }
  },
  mounted() {
    var _t = this
    window.onresize = () => {
      return (() => {
        _t.height = window.innerHeight
        _t.width = window.innerWidth
      })()
    }
  },
  methods: {
    // 顶部布局高度  navbar 50px    tagsview 34px
    getTopView() {
      return 50 + 34
    }
  },
  computed: {
    getHeaderHeight() {
      var _t = this
      // if (_t.isTopMenu()) {
      //   return 64
      // }
      // if (_t.isMobile()) {
      //   return 0
      // }
      return this.getTopView()
    },
    getLeftMenuWidth() {
      var _t = this
      // if (_t.isTopMenu()) {
      //   return 0
      // }
      // if (_t.isMobile()) {
      //   return 0
      // }
      // if (_t.sidebarOpened) {
      //   return 220
      // }
      return 0
    },
    getCurWidth() {
      var _t = this
      if (_t.wrapWidth) {
        return (_t.width) + 'px'
      }
      return '100%'
    },
    getCurHeight() {
      var _t = this
      return (_t.height - _t.getTopView()) + 'px'
    },
    getFloatHeightValue() {
      var _t = this
      return (_t.height - _t.getTopView() - _t.top - _t.bottom)
    },
  }
}
</script>
<style scoped>
    .center {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
</style>
